export const MOST_VIEWED_ARTICLES_MODEL = [
  {
    Topic: '',
    Url: '',
    PublishedOn: '',
    CategoryName: '',
    CategorySlug: '',
    SubCategoryName: '',
    SubCategorySlug: '',
    FeaturedImage: null,
    FeaturedVideo: null
  }
]
